// Module
var code = `<predicate predicates="\$ctrl.predicates"
           type="\$ctrl.type"
           access-input="\$ctrl.inputDefinition"
           ng-disabled="\$ctrl.ngDisabled">

  <select ng-options="ar.value as ar.label for ar in \$ctrl.inputDefinitions"
          ng-model="\$ctrl.inputDefinition"
          ng-change="\$ctrl.inputDefinitionChanged()"
          ng-disabled="\$ctrl.ngDisabled"
          required>
  </select>

  <select ng-if="\$ctrl.type == 'BRANCH_ACCESS_MODE'"
          ng-model="\$ctrl.value"
          ng-change="\$ctrl.valueChanged()"
          ng-disabled="\$ctrl.ngDisabled"
          required>
    <option value="MOTHER_BRANCH">User and product from the same branch</option>
    <option value="INTER_BRANCH">User and product from different branch</option>
  </select>

  <multiselect ng-if="\$ctrl.type == 'IN'"
               items="\$ctrl.options"
               ng-model="\$ctrl.value"
               select-all-option="true"
               ng-required="true"
               ng-change="\$ctrl.valueChanged()">
  </multiselect>
</predicate>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/predicates/mother-branch-predicate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;